import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-manage-preview-latest-posts',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  templateUrl: './manage-preview-latest-posts.component.html',
  styleUrl: './manage-preview-latest-posts.component.scss'
})
export class ManagePreviewLatestPostsComponent {
  @Input() posts: any[] = [];

  @Output() postClick = new EventEmitter<any>();

  openPost(post: any): void {
    this.postClick.emit(post);
  }
}